<template>
  <div>
    <a
      class="button"
      :class="[{disabled: disabled}, color]"
      :style="radiusStyle"
      @click="clicked"
      v-text="text"
    ></a>
  </div>
</template>

<script>
import BorderMixin from './mixins/BorderMixin'
import { EVENT } from '@/constants/event'

export default {
  name: 'GSButton',
  mixins: [BorderMixin],
  props: {
    text: {
      type: String,
      required: true
    },
    disabled: {
      type: Boolean,
      required: false
    },
    color: {
      type: String,
      default: ''
    }
  },
  methods: {
    clicked () {
      !this.disabled && this.$emit(EVENT.CLICKED)
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../assets/scss/vars/base';

.button {
  background: linear-gradient(-180deg, #FFE191 0%, #FFD15F 98%);
  border-radius: $base-size * 6;
  padding: $base-size * 26;
  width: 100%;
  height: $base-size * 90;
  color: #6C4F08;
  text-align: center;
  font-size: $font-size-s;
  display: inline-block;

  .disabled {
    background: #3B4951;
    color: #CDCDCD;
  }
}

.blue {
  background: linear-gradient(-180deg, #377092 0%, #316484 98%);
  color: #A2CCEA;
}
</style>



// WEBPACK FOOTER //
// src/components/GSButton.vue